// extracted by mini-css-extract-plugin
module.exports = {"LoaderSpinner":"LoaderSpinner_LoaderSpinner__3ggx2"};